import React, {Component} from 'react';
import ContinueWithAppModal from "./ContinueWithAppModal";
import AppContext from "../contexts/AppContext";
import clientStorage from "../utils/client-storage";
import analyticsHelper from "../helpers/analytics.helper";
import {webviewPhotoSelect} from "@vicman-wi/webview-api/functions/content/photo-select";
import {WebviewEventSubscriber} from "@vicman-wi/webview-api/tools/WebviewEventSubscriber";

export default class FileChooseButton extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      image: null,
    };

    this.fileFieldRef = React.createRef();

    this.handleBrowserFileSelected = this.handleBrowserFileSelected.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleError = this.handleError.bind(this);
    this.triggerSelectFile = this.triggerSelectFile.bind(this);
    this.logFileSelected = this.logFileSelected.bind(this);
  }

  componentDidMount() {
    this.handleWebviewPhotosSelectedEvent.subscribe(window.webviewEvents.photosSelected);
  }

  componentWillUnmount() {
    this.handleWebviewPhotosSelectedEvent.unsubscribe();
  }

  handleWebviewPhotosSelectedEvent = new WebviewEventSubscriber((data) => {
    if (!data || !data.photos || data.photos.length === 0) {
      return;
    }

    const photo = data.photos.pop();

    this.logFileSelected();

    const imageUrl = photo.image_url.replace("http://", "https://");
    this.props.onFileSelected && this.props.onFileSelected(imageUrl);
  });

  triggerSelectFile() {
    if (window.clientConfig.isWebview) {
      const params = {
        func: "pw_onPhotosSelected",
        use_crop: 0,
        num_photos: 1,
        show: "gallery",
        tab: "faces",
        neurocamera: 1,
        face_count: 1,
        face_percent_gte: 2,
      };

      webviewPhotoSelect(params);
    } else {
      if (this.fileFieldRef.current) {
        this.fileFieldRef.current.value = "";
        this.fileFieldRef.current.click();
      }
    }
  }

  handleError(code, message) {
    this.props.onError && this.props.onError(code, message);
  }

  logFileSelected() {
    analyticsHelper.photoSelected();
  }

  handleBrowserFileSelected(file) {
    this.logFileSelected();
    this.props.onFileSelected && this.props.onFileSelected(file);
  }

  handleClick(e) {
    if ((window.clientConfig.isWebMobile || window.clientConfig.isWebMobileDesktopMode) && !window.appConfig.isTestInstance) {
      const limit = window.clientConfig.isWebMobile
        ? window.appConfig.processings.mobilePhotosLimit
        : window.appConfig.processings.mobileDesktopModePhotosLimit;

      if (clientStorage.getProcessedPhotosAmount() >= limit) {
        this.context.pushModal(<ContinueWithAppModal
          key="FileChooseButton_ContinueWithAppModal"
        />);
        return;
      }
    }

    this.props.onClick && this.props.onClick(e);
    this.triggerSelectFile();
  }

  render() {
    if (this.props.hidden) {
      return <React.Fragment />;
    }

    return <React.Fragment>
      <button
        disabled={this.props.disabled}
        className={this.props.className}
        onClick={this.handleClick.bind(this)}>
        <span
          hidden={this.props.progress === 0}
          className="effects"
          style={{width: (this.props.progress*100) + "%"}}>
            <span children={this.props.progressContent || ""} />
        </span>
        {this.props.children}
      </button>

      <input
        className="file-field-hidden"
        type="file"
        accept="image/*"
        ref={this.fileFieldRef}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => this.handleBrowserFileSelected(e.target.files[0])} />
    </React.Fragment>;
  }
}

FileChooseButton.contextType = AppContext;